import { render, staticRenderFns } from "./AccountsReceivableHistory.vue?vue&type=template&id=afbb7e66&scoped=true"
import script from "./AccountsReceivableHistory.vue?vue&type=script&lang=js"
export * from "./AccountsReceivableHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afbb7e66",
  null
  
)

export default component.exports